import { Fragment, useCallback, useState } from "react";
import { Container } from "reactstrap";
import SocialAppTabContent from "./UserContext/UserContext";
import UserProfile from "./UserProfile/UserProfile";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, SocialApp } from "../../../Constants/Constants";

const SocialAppContainer = () => {
  const [activeTab, setActiveTab] = useState(1);
  const callback = useCallback((tab: number) => setActiveTab(tab), []);

  return (
    <Fragment>
      <Breadcrumbs mainTitle={SocialApp} parent={Apps} />
      <Container fluid>
        <div className="user-profile social-app-profile">
          <UserProfile callback={callback} />
          <SocialAppTabContent activeTab={activeTab} />
        </div>
      </Container>
    </Fragment>
  );
};

export default SocialAppContainer;
